import { Component } from "react";
import { graphql } from "gatsby";
import { extract } from "@parksandresorts/core";
import styles from "./fact-block.module.less";
import borderPatterns from "styles/theming/border-patterns.module.less";

export default class FactBlock extends Component {
  constructor(props) {
    super(props);

    this.headline = extract(props, "headline");
    this.ingress = extract(props, "ingress.ingress");
    this.facts = extract(props, "facts.list");
    this.borderPattern = extract(props, "borderPattern");
    this.componentTheme = extract(props, "componentTheme");
  }

  renderFactList(list) {
    if (!list) {
      return null;
    }

    return (
      <ul className={[styles.factList, this.borderPattern ? styles.noPadding : ""].join(" ")}>
        {list.map((item, index) => (
          <li key={index} className={[styles.listItem, index % 2 !== 0 ? styles.unevenItem : ""].join(" ")}>
            <h6 className={styles.factName}>{item.key}</h6>
            <span className={[styles.fact].join(" ")}>{item.value}</span>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    return (
      <section
        className={[
          "block block--floating block--max-width-narrow",
          this.componentTheme ? `component-theme-${this.componentTheme}` : "",
        ].join(" ")}
        data-contentful-id={this.props.contentful_id}
      >
        <div className={[borderPatterns[this.borderPattern + "_bottom"]].join(" ")}>
          <div className={styles.factBlockWrapper}>
            {this.headline && <h3 className={styles.headline}>{this.headline}</h3>}
            {this.ingress && <p className={styles.ingress}>{this.ingress}</p>}
          </div>
          {this.renderFactList(this.facts)}
        </div>
      </section>
    );
  }
}

export const fragmentFactBlock = graphql`
  fragment FactBlock on ContentfulFactBlock {
    contentful_id
    id
    headline
    ingress {
      ingress
    }
    facts {
      list {
        key
        value
      }
    }
    componentTheme
    borderPattern
  }
`;
